import { PaymentSystem } from './PaymentSystem';

export enum SubscriptionStatus {
  None = 'None',
  Signed = 'Signed',
  Canceled = 'Canceled',
  WaitingSigned = 'WaitingSigned'
}

export enum ShowChatEnum {
  Hide = 0,
  ShowIntercom = 1,
  ShowPreSale = 2
}

export class ProviderData {
  /** Email used for receive notification or just contact with provider */
  Balance: string;
  CanBuyCreditsWithoutSubscription?: boolean;
  Chat: ShowChatEnum;
  CompanyName: string;
  EmailNotificationsTo: string;
  EnableScreenRecording?: boolean;
  ExtendedPaymentDate: string;
  Id: string;
  IsPostPayment: boolean;
  IsTest: boolean;
  IsVerified: boolean;
  LicenseMode: LicenseMode;
  ManageRmmApiTokens: boolean;
  McpReadAccess: boolean;
  McpFullAccess: boolean;
  PasswordRecoveryEnabled: boolean;
  PaymentSystem: PaymentSystem;
  Phone: string;
  RemoteAccessEnabled: boolean;
  RmmCeEnabled: boolean;
  SubscriptionCurrencySign: string;
  SubscriptionStatus: SubscriptionStatus;
  TimeZone: string;
  TimeZoneDisplayName: string;
  TimeZoneOffset: number;
  TimeZoneSpecified?: boolean;
}

export enum LicenseMode {
  None = 'None',
  Monthly = 'Monthly',
  PostPaymentV1Monthly = 'PostPaymentV1Monthly',
  CumulativeV2Monthly = 'CumulativeV2Monthly',
  CumulativeV3Monthly = 'CumulativeV3Monthly',
  CumulativeV4Monthly = 'CumulativeV4Monthly',
  Yearly = 'Yearly',
  CumulativeV2Annual = 'CumulativeV2Annual',
  CumulativeV3Annual = 'CumulativeV3Annual',
  CumulativeV4Annual = 'CumulativeV4Annual'
}
